<template>
    <svg
        fill="none"
        viewBox="0 0 334 26"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_16882_10247)">
            <path
                clip-rule="evenodd"
                d="M22.4666 13.1209C22.4666 18.2308 18.5072 22.0847 13.2569 22.0847C8.10983 22.0847 4.0772 18.1859 4.0772 13.2116C4.0772 8.16897 8.1731 4.21865 13.4067 4.21865C18.5716 4.21865 22.4666 8.04573 22.4666 13.1209ZM13.3757 1.06152C6.52475 1.06152 0.950329 6.51198 0.949219 13.2139C0.950329 19.8295 6.44372 25.2105 13.197 25.2105C20.2643 25.2105 25.5945 19.9863 25.5945 13.0604C25.5945 6.33273 20.2277 1.06152 13.3757 1.06152Z"
                fill="black"
                fill-rule="evenodd"
            />
            <path
                clip-rule="evenodd"
                d="M66.4044 14.4774H75.6251V11.2194H66.4033V4.70241H82.1963V1.57666H63.2764V24.6355H82.8568V21.5098H66.4044V14.4774ZM46.3755 11.2206H36.7441V4.70129H46.5243C47.7541 4.70129 48.3524 4.86262 48.5944 4.95561C49.8199 5.46649 50.5502 6.54986 50.5502 7.85618C50.5502 10.6346 48.2792 11.2183 46.3755 11.2183V11.2206ZM36.7441 14.4774H46.3755C49.8898 14.4774 51.5992 15.6762 51.5992 18.1409C51.5992 19.1918 51.204 20.0589 50.4581 20.6505L50.4559 20.6527C49.7422 21.2353 49.1061 21.5098 46.3755 21.5098H36.7441V14.4774ZM51.6403 12.5762C53.0833 11.2463 53.6771 9.90304 53.6771 8.00854C53.6771 4.04029 50.8788 1.57666 46.3755 1.57666H33.6172V24.6355H46.3755C49.377 24.6355 50.8655 24.482 52.5205 23.0043C53.9235 21.7451 54.6961 20.0298 54.6961 18.1723C54.6961 15.8408 53.6416 13.9116 51.6403 12.5762ZM242.689 19.7733L228.435 1.57666H225.457V24.6355H228.554V6.67421L242.809 24.6355H245.817V1.57666H242.689V19.7733Z"
                fill="black"
                fill-rule="evenodd"
            />
            <mask
                id="mask0_16882_10247"
                height="25"
                maskUnits="userSpaceOnUse"
                style="mask-type: alpha"
                width="160"
                x="146"
                y="1"
            >
                <path
                    d="M305.354 25.122H146.887V1.06152H305.354V25.122Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_16882_10247)">
                <path
                    clip-rule="evenodd"
                    d="M288.9 14.4776H298.121V11.1345H288.9V4.70263H304.693V1.57688H285.772V24.6357H305.353V21.51H288.9V14.4776ZM265.964 14.4776H273.696V17.991C273.696 20.7157 270.002 21.6568 269.264 21.817C268.386 21.994 267.484 22.0859 266.582 22.0859C261.038 22.0859 257.014 18.3406 257.014 13.1814C257.014 8.08831 261.102 4.2489 266.523 4.2489C269.857 4.2489 271.917 5.54513 274.159 7.63569L274.326 7.79142L276.435 5.55521L276.275 5.39388C273.277 2.40033 270.378 1.12202 266.582 1.12202C259.379 1.12202 253.946 6.29352 253.946 13.1523C253.946 20.1398 259.261 25.2105 266.582 25.2105C268.003 25.2156 269.418 25.0187 270.784 24.6257C273.689 23.754 276.793 21.5996 276.793 18.1725V11.2208H265.964V14.4787V14.4776ZM168.404 13.1209C168.404 18.2308 164.445 22.0847 159.194 22.0847C154.046 22.0847 150.015 18.1859 150.015 13.2116C150.015 8.16897 154.113 4.21865 159.344 4.21865C164.509 4.21865 168.404 8.04573 168.404 13.1209ZM159.314 1.06152C152.462 1.06152 146.887 6.51311 146.887 13.2116C146.887 19.8284 152.381 25.2105 159.134 25.2105C166.202 25.2105 171.531 19.9863 171.531 13.0604C171.531 6.33273 166.165 1.06152 159.314 1.06152Z"
                    fill="black"
                    fill-rule="evenodd"
                />
            </g>
            <path
                clip-rule="evenodd"
                d="M132.984 11.2207H123.444V4.70141H132.985C135.892 4.70141 137.191 5.70636 137.191 7.95937C137.191 10.2146 135.892 11.2196 132.984 11.2196V11.2207ZM132.984 1.57678H120.346V24.6357H123.444V14.4775H132.985C137.42 14.4775 140.288 11.9198 140.288 7.96049C140.288 4.08186 137.42 1.57678 132.984 1.57678ZM94.4457 11.2207V4.70141H103.986C106.893 4.70141 108.192 5.70636 108.192 7.95937C108.192 10.2146 106.893 11.2196 103.985 11.2196H94.4457V11.2207ZM105.516 14.3666C109.068 13.84 111.288 11.4425 111.288 7.96049C111.288 4.16477 108.537 1.68881 104.26 1.58574V1.57678H91.3477V24.6357H94.4457V14.4775H102.057L107.241 24.6357H110.785L105.568 14.4697L105.516 14.3666ZM212.244 24.6357H215.341V1.54541H212.244V24.6357ZM182.759 1.57678H179.663V24.6357L202.545 24.639V21.5133L182.759 21.5099V1.57678Z"
                fill="black"
                fill-rule="evenodd"
            />
            <path
                clip-rule="evenodd"
                d="M192.996 1.54541H189.891V14.3733L202.544 14.3767V11.242L192.996 11.2386V1.54541ZM316.432 11.205V4.68685H325.973C328.881 4.68685 330.178 5.69291 330.178 7.94704C330.178 10.1989 328.88 11.205 325.973 11.205H316.432ZM327.503 14.3509C331.056 13.8244 333.275 11.4268 333.275 7.94592C333.275 4.1502 330.525 1.67425 326.247 1.57118V1.56222H313.335V24.62H316.432V14.4618H324.043L329.228 24.62H332.772L327.555 14.454L327.503 14.3498V14.3509Z"
                fill="black"
                fill-rule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="clip0_16882_10247">
                <rect
                    fill="white"
                    height="25.7679"
                    transform="translate(0.949219 0.0395508)"
                    width="333"
                />
            </clipPath>
        </defs>
    </svg>
</template>
